import React from 'react'
import RupayUpiLoadRequest from '../../myapp/services/rupayUpi'

function RupayUpiLoadWalletPage() {
  return (
    <RupayUpiLoadRequest/>
  )
}

export default RupayUpiLoadWalletPage


